import React from "react";

import "./Logo.scss";

export const Logo = () => (
    <a href="/" className="logo__container">
        <div className="logo__image" />
    </a>
);
